module.exports = __webpack_public_path__ + "img/udon-noodles-1.4b5fbe00.jpg";